/**
 * Created by lk on 17/6/4.
 */
import axios from "../../utils/axios";

// 谁最懂我相关

// 列表
export function categoryList(query) {
    return axios({
        url: "/admin/category/category/index",
        method: "get",
        params: query
    });
}

// 保存
export function categorySave(data, formName, method = "post") {
    var url = formName === "add" ? "/admin/category/Category/storage" : "/admin/category/Category/storage";
    return axios({
        url: url,
        method: method,
        data: data
    });
}

// 删除
export function categoryDelete(data) {
    return axios({
        url: "/admin/category/Category/delete",
        method: "post",
        data: data
    });
}
// 列表
// export function categoryChildList(query) {
//     return axios({
//         url: "/categoryChild",
//         method: "get",
//         params: query
//     });
// }

// 保存
export function categoryChildSave(data, formName, method = "post") {
    var url = formName === "add" ? "/admin/category/Category/storage" : "/admin/category/Category/storage";
    return axios({
        url: url,
        method: method,
        data: data
    });
}

// 删除
export function categoryChildDelete(query) {
    return axios({
        url: "/admin/category/Category/delete",
        method: "post",
        data:query
    });
}


// 观点列表
export function cateSwitchList(query) {
    return axios({
        url: "/admin/app/Users/cateSwitchList",
        method: "get",
        params:query
    });
}

// 列表开关操作
export function switchChange(data) {
    return axios({
        url: "/admin/app/Users/switchChange",
        method: "post",
        data:data
    });
}

// 定制列表（开屏动画列表）
export function dzTagList(data) {
    return axios({
        url: "/admin/app/Users/dzTagList",
        method: "post",
        data:data
    });
}

// 定制tag添加
export function openScreen(data) {
    return axios({
        url: "/admin/app/Users/openScreen",
        method: "post",
        data:data
    });
}

// 定制tag详情
export function dzTagDetail(data) {
    return axios({
        url: "/admin/app/Users/dzTagDetail",
        method: "post",
        data:data
    });
}

// 定制tag修改
export function openScreenUpd(data) {
    return axios({
        url: "/admin/app/Users/openScreenUpd",
        method: "post",
        data:data
    });
}

// 定制tag修改
export function openScreenStop(data) {
    return axios({
        url: "/admin/app/Users/openScreenStop",
        method: "post",
        data:data
    });
}

// 观点管理列表
export function cateExamineList(data) {
    return axios({
        url: "/admin/app/Users/cateExamineList",
        method: "post",
        data:data
    });
}

// 观点列表
export function cateExamineCommentList(data) {
    return axios({
        url: "/admin/app/Users/cateExamineCommentList",
        method: "post",
        data:data
    });
}


// 观点审核
export function ContentExamine(data) {
    return axios({
        url: "/admin/app/Users/ContentExamine",
        method: "post",
        data:data
    });
}

// 用户放行
export function userSaveExamine(data) {
    return axios({
        url: "/admin/app/users/userExmineChange",
        method: "post",
        data: data
    });
}

// 观点tag 总开关
export function viewpointSwitch(data) {
    return axios({
        url: "/admin/cate/Cate/viewpointSwitch",
        method: "post",
        data: data
    });
}

// 观点显示 总开关控制
export function viewpointSwitchMaster(data) {
    return axios({
        url: "/admin/cate/Cate/viewpointSwitchMaster",
        method: "post",
        data: data
    });
}

// 总开关状态
export function masterSwitchState(data) {
    return axios({
        url: "/admin/cate/Cate/masterSwitchState",
        method: "post",
        data: data
    });
}


